import * as yup from 'yup';

const urlValidation = yup.string().trim().url('Must be a valid URL');

export const CreateUpdateAIModelValidationSchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.required('Name is required')
		.max(255, 'Name must be at most 255 characters'),
	description: yup
		.string()
		.trim()
		.max(255, 'Description must be at most 255 characters'),
	active: yup.boolean(),
	inference_endpoint: urlValidation.required(
		'Inference endpoint is required',
	),
	liveness_endpoint: urlValidation,
	batch_inference_endpoint: urlValidation,
});
